// Libs
import classNames from 'classnames/bind';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { formatDate } from '~/utils/helper/common';
import { DateFormatEnum } from '~/utils/enum/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { INote } from '~/utils/interface/note';
// Styles, images, icons
import styles from './ModalDetailNote.module.scss';

type Props = {
  isOpen: boolean;
  data: INote;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const ModalDetailNote = (props: Props) => {
  //#region Destructuring Props
  const { isOpen, data, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/notes', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleCancelNoteDetail = () => {
    onClose();
  };

  //#endregion Handle Function

  return (
    <Dialog id='modalDetailNotePage' open={isOpen} fullWidth maxWidth={'md'} onClose={handleCancelNoteDetail}>
      <DialogTitle>{t('note_detail_title')}</DialogTitle>

      <DialogContent dividers={true}>
        <Box component={'div'} className={cx('content')}>
          <Box component={'div'} className={cx('titleCreateAt')}>
            <Typography component='span' className={cx('title')}>
              {t('note_detail_title_created_at')}
            </Typography>

            <Typography component='span' className={cx('title')}>
              {data?.createdAt
                ? formatDate(data?.createdAt, DateFormatEnum.MM_DD_YYYY_HH_AM_PM)
                : EMPTY_STRING}
            </Typography>
          </Box>

          <Box component={'div'} className={cx('titleContent')}>
            <Typography component='span' className={cx('title')}>
              {t('note_detail_title_content')}
            </Typography>

            <Typography component='span' className={cx('textContent')}>
              {data?.content || EMPTY_STRING}
            </Typography>
          </Box>
        </Box>

        <Box className={cx('button')}>
          <Button variant='outlined' onClick={handleCancelNoteDetail}>
            {t('common_action_cancel', { ns: 'common/base' })}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalDetailNote;
